var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "800", persistent: "" },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-toolbar",
            { attrs: { color: "primary", dark: "", flat: "" } },
            [
              _c("v-toolbar-title", [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { icon: "" }, on: { click: _vm.close } },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "modal-content" },
            _vm._l(_vm.periods, function (period, index) {
              return _c("div", { key: index, staticClass: "period-item" }, [
                _c("div", { staticClass: "period-header" }, [
                  _vm._v(
                    "\n          Período: " +
                      _vm._s(_vm.formatPeriodDate(period.startDate)) +
                      " à " +
                      _vm._s(_vm.formatPeriodDate(period.endDate)) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "period-content" }, [
                  _c("div", { staticClass: "period-metric" }, [
                    _c("span", { staticClass: "metric-label" }, [
                      _vm._v("Quantidade Escoado:"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "metric-value" }, [
                      _vm._v(
                        _vm._s(_vm.formatNumber(period.quantitySellout || 0))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "period-metric" }, [
                    _c("span", { staticClass: "metric-label" }, [
                      _vm._v("SDZ Aceleradores (Bruto):"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "metric-value" }, [
                      _vm._v(
                        _vm._s(_vm.formatCurrency(period.acceleratorGross || 0))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "period-metric" }, [
                    _c("span", { staticClass: "metric-label" }, [
                      _vm._v("SDZ Aceleradores (Líquido):"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "metric-value" }, [
                      _vm._v(
                        _vm._s(_vm.formatCurrency(period.acceleratorNet || 0))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "period-metric" }, [
                    _c("span", { staticClass: "metric-label" }, [
                      _vm._v("Seedz (Bruto):"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "metric-value" }, [
                      _vm._v(
                        _vm._s(_vm.formatCurrency(period.seedzGross || 0))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "period-metric" }, [
                    _c("span", { staticClass: "metric-label" }, [
                      _vm._v("Seedz (Líquido):"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "metric-value" }, [
                      _vm._v(_vm._s(_vm.formatCurrency(period.seedzNet || 0))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "period-metric" }, [
                    _c("span", { staticClass: "metric-label" }, [
                      _vm._v("Diferença:"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "metric-value" }, [
                      _vm._v(
                        _vm._s(_vm.formatCurrency(period.difference || 0))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "period-metric" }, [
                    _c("span", { staticClass: "metric-label" }, [
                      _vm._v("Seedz Pago:"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "metric-value" }, [
                      _vm._v(_vm._s(_vm.formatCurrency(period.seedzPaid || 0))),
                    ]),
                  ]),
                ]),
              ])
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }